import BrowserStore from '../lib/browser-store'

export default new BrowserStore('mealimeAuthToken')
